import { render, staticRenderFns } from "./GSnsButton.vue?vue&type=template&id=1e6f3ead&scoped=true&"
import script from "./GSnsButton.vue?vue&type=script&lang=ts&"
export * from "./GSnsButton.vue?vue&type=script&lang=ts&"
import style0 from "./GSnsButton.vue?vue&type=style&index=0&id=1e6f3ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6f3ead",
  null
  
)

export default component.exports